import { useMemo, useState } from 'react';
import { Panel } from '../../../components/panels/Panel';
import { VERALLIA_DASHBOARD_MOCK_DETECTIONS } from '../../../data/verallia-dashboard-mock-data';
import {
  filterVeralliaDashboardDetections,
  formatVeralliaDashboardDateTime,
  getVeralliaDashboardDefectClassification,
  getVeralliaDashboardLastCompletedShiftRange,
  getVeralliaDashboardLinesReporting,
  getVeralliaDashboardShiftEvolution,
} from '../../../services/dashboard/verallia-dashboard-service';
import {
  VeralliaDashboardKpi,
  VeralliaDashboardPictureWall,
} from './components/VeralliaDashboardBlocks';
import {
  VeralliaDashboardDefectClassification,
  VeralliaDashboardShiftEvolutionChart,
} from './components/VeralliaDashboardCharts';
import { VeralliaDashboardDetectionsTable } from './components/VeralliaDashboardDetectionsTable';

export const VeralliaDashboardLastShiftReport = () => {
  const [page, setPage] = useState(1);

  const shiftRange = useMemo(() => {
    return getVeralliaDashboardLastCompletedShiftRange();
  }, []);

  const shiftDetections = useMemo(() => {
    return filterVeralliaDashboardDetections(
      VERALLIA_DASHBOARD_MOCK_DETECTIONS,
      {
        lines: [],
        defects: [],
        start: shiftRange.start,
        end: shiftRange.end,
      },
    );
  }, [shiftRange]);

  const classification = useMemo(() => {
    return getVeralliaDashboardDefectClassification(shiftDetections);
  }, [shiftDetections]);

  const evolution = useMemo(() => {
    return getVeralliaDashboardShiftEvolution(shiftDetections, shiftRange);
  }, [shiftDetections, shiftRange]);

  return (
    <Panel title="LAST SHIFT REPORT">
      <div className="mx-auto flex w-11/12 flex-col gap-4 py-6">
        <div className="text-sm text-perception-gray-600">
          Shift {shiftRange.id} · {formatVeralliaDashboardDateTime(shiftRange.start, false)} → {formatVeralliaDashboardDateTime(shiftRange.end, false)} · closed
        </div>

        <div className="grid grid-cols-2 gap-4">
          <VeralliaDashboardKpi
            label="Detections in shift"
            value={shiftDetections.length}
          />

          <VeralliaDashboardKpi
            label="Lines impacted"
            value={getVeralliaDashboardLinesReporting(shiftDetections)}
          />
        </div>

        <div className="grid grid-cols-1 gap-4 2xl:grid-cols-2">
          <VeralliaDashboardShiftEvolutionChart evolution={evolution}/>
          <VeralliaDashboardDefectClassification classification={classification} fixedHeight/>
        </div>

        <VeralliaDashboardPictureWall
          detections={shiftDetections}
        />

        <div className="flex flex-col gap-3">
          <div className="text-xs font-semibold uppercase tracking-wider text-perception-gray-600">
            Shift detections · {shiftDetections.length} recorded
          </div>

          <VeralliaDashboardDetectionsTable
            detections={shiftDetections}
            page={page}
            onPageChange={setPage}
          />
        </div>
      </div>
    </Panel>
  );
};